// extracted by mini-css-extract-plugin
export default {"edited-value-bullet":"components-settings-budget-forecast-table-budget-forecast-td-number-module__edited-value-bullet"};